<template>
  <div id="app" :class="[
    this.viewingViaShareLink && 'app--viewing-via-share-link',
    this.shareLinkIsProductDetailPage && 'app--share-link-is-product-detail-page',
    !this.gaIsSetup && 'app--ga-hide'
  ]">
    <global-toolbar :disabled="true" />

    <!--
    <header class="header">
      <button type="button" class="header-menu" title="Menu"
        v-show="isAuthorized"
        @click.stop.prevent="toggleClass('menu-active')"
      >Menu</button>

      <nav class="header-nav"
        v-show="isAuthorized"
      >
        <ul class="header-nav__list">
          <router-link class="header-nav__item" tag="li" :to="{ name: 'Activities' }" exact>
            <a class="header-nav__link">Activities</a>
          </router-link>
          <router-link class="header-nav__item" tag="li" :to="{ name: 'Products' }">
            <a class="header-nav__link">Products</a>
          </router-link>
          <router-link class="header-nav__item" tag="li" :to="{ name: 'Analytics' }" exact>
            <a class="header-nav__link">Analytics</a>
          </router-link>
        </ul>
      </nav>

      <div class="logo" title="Seemore" itemscope itemtype="http://schema.org/Organization">
        <router-link class="logo__link" itemprop="url" :to="{ name: 'Activities' }" exact>Seemore</router-link>
        <meta itemprop="logo" content="/static/logo.png" />
      </div>

      <div class="header-account"
        @mouseenter="menuEvent"
        @mouseleave="menuEvent"
        v-touch:tap="menuEvent"
      >
        <a href="#" class="header-account__link"
          v-show="isAuthorized"
          @click.stop.prevent
          :style="{ backgroundImage: profilePicture() ? `url(${ this.profile.picture })` : 'inherit' }"
        >
          <span class="header-account__initial"
            v-if="!profilePicture()"
          >{{ firstInitial() }}</span>
        </a>

        <div class="header-account-drop">
          <ul class="header-account-drop__list">
            <li class="header-account-drop__item">
              <a href="#" class="header-account-drop__link" @click.stop.prevent>Notifications</a>
            </li>
            <li class="header-account-drop__item">
              <a href="#" class="header-account-drop__link" @click.stop.prevent>Profile</a>
            </li>
            <li class="header-account-drop__item">
              <a href="#" class="header-account-drop__link" @click.stop.prevent>Connected Sites</a>
            </li>
            <li class="header-account-drop__item">
              <a href="#" class="header-account-drop__link" @click.stop.prevent>Account</a>
            </li>
            <li class="header-account-drop__item">
              <a href="/logout" class="header-account-drop__link" @click="logout()">Log Out</a>
            </li>
          </ul>
        </div>
      </div>

      <button type="button" class="header-more icon--menu" title="More"
        v-show="isAuthorized"
      >More</button>
    </header>
    -->

    <nav class="mobile-menu">
      <button type="button" @click.stop.prevent="toggleClass('menu-active')" class="mobile-menu__button" title="Close Menu">Close Menu</button>

      <ul class="mobile-menu__list">
        <!--
        <router-link class="mobile-menu__item" @click.native="toggleClass('menu-active')" tag="li" :to="{ name: 'Activities' }" exact>
          <a class="mobile-menu__link">Activities</a>
        </router-link>
        -->
        <router-link class="mobile-menu__item" @click.native="toggleClass('menu-active')" tag="li" :to="{ name: 'Products' }" exact>
          <a class="mobile-menu__link">Products</a>
        </router-link>
        <!--
        <router-link class="mobile-menu__item" @click.native="toggleClass('menu-active')" tag="li" :to="{ name: 'Analytics' }" exact>
          <a class="mobile-menu__link">Analytics</a>
        </router-link>
        -->
      </ul>

      <div class="mobile-menu-phone">
        <a href="tel:+18885554332" class="mobile-menu-phone__link">+1 (888) Seemore</a>
      </div>
    </nav>

    <router-view></router-view>

    <vue-progress-bar></vue-progress-bar>

    <modal />
    <UpgradeModal :isVisible="isUpgradeModalVisible" />

    <RemainingOrdersLoadingIndicator />
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import RemainingOrdersLoadingIndicator from '@/components/RemainingOrdersLoadingIndicator'
  import GlobalToolbar from '@/components/GlobalToolbar'
  import Modal from '@/components/Modal/Modal.vue'
  import UpgradeModal from '@/components/UpgradeModal.vue'
  import { getProfile, isLoggedIn, getShopDomain, logout } from '@/utils/auth.js'

  export default {
    name: 'app',
    components: {
      'global-toolbar': GlobalToolbar,
      'modal': Modal,
      UpgradeModal,
      RemainingOrdersLoadingIndicator
    },
    data () {
      return {
        isAuthorized: false,
        profile: getProfile(),
        isUpgradeModalVisible: false
      }
    },
    computed: {
      ...mapState(
        'user',
        [
          'viewingViaShareLink',
          'shareLinkIsProductDetailPage'
        ]
      ),
      ...mapState(
        'ga',
        [
          'gaIsSetup'
        ]
      )
    },
    methods: {
      authorized () {
        if (isLoggedIn() === true && getShopDomain().length) {
          this.isAuthorized = true
        }
      },
      firstInitial () {
        if (!this.profile) {
          return null
        }
        return this.profile.name.charAt(0)
      },
      logout () {
        logout()
      },
      menuEvent (e) {
        let el = e.currentTarget

        if (e.type === 'mouseenter') {
          el.classList.add('hover')
        }

        if (e.type === 'mouseleave') {
          el.classList.remove('hover')
        }

        if (e.type === 'touchend') {
          if (el.classList.contains('hover')) {
            el.classList.remove('hover')
          } else {
            el.classList.add('hover')
          }
        }
      },
      profilePicture () {
        if (!this.profile) {
          return null
        }
        return this.profile.picture
      }
    },
    created () {
      this.authorized()
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue